
const DividerLine = () => {
  return (
    <div className='tw-overflow-auto tw-overflow-x-hidden'>
      <hr className='tw-w-full tw-border-solid tw-border-opacity-10 tw-border-black tw-rounded-sm'/>
    </div>
  )
}

export default DividerLine

